/**
 * Support Accordion
 * Progressive disclosure container - shows value preview when collapsed
 * UX Philosophy: Cognitively Respectful, Momentum-Preserving
 */

import React from 'react';
import { ChevronDown, ChevronUp, Sparkles } from 'lucide-react';

const SupportAccordion = ({ isExpanded, onToggle, metrics, children }) => {
  return (
    <div className="border-2 border-slate-200 rounded-lg overflow-hidden bg-white/60">
      {/* Accordion Header - Always Visible */}
      <button
        onClick={onToggle}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-white/80 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-indigo-600" />
          <span className="text-sm font-semibold text-slate-900">
            See your full support plan
          </span>
          {metrics.totalTimeSavings > 0 && !isExpanded && (
            <span className="text-xs font-medium text-teal-700 bg-teal-50 px-2 py-0.5 rounded-full">
              saves {metrics.totalTimeSavingsHours}h
            </span>
          )}
        </div>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-slate-600" />
        ) : (
          <ChevronDown className="w-5 h-5 text-slate-600" />
        )}
      </button>

      {/* Accordion Content - Progressive Disclosure */}
      {isExpanded && (
        <div className="px-4 pb-4 space-y-4 border-t border-slate-200 pt-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default SupportAccordion;
